/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ValidateSubmitOrderOptions,
  ValidateSubmitOrderStatus200,
  ValidateSubmitOrderStatus400,
  ValidateSubmitOrderStatus401,
  ValidateSubmitOrderStatus500,
} from '../types/ValidateSubmitOrder'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { validateSubmitOrder } from '../clients/validateSubmitOrder'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const validateSubmitOrderMutationKey = () => [{ url: '/v1/orders/validate' }] as const

export function validateSubmitOrderMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = validateSubmitOrderMutationKey()
  return mutationOptions<
    ValidateSubmitOrderStatus200,
    ResponseErrorConfig<
      ValidateSubmitOrderStatus400 | ValidateSubmitOrderStatus401 | ValidateSubmitOrderStatus500
    >,
    ValidateSubmitOrderOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return validateSubmitOrder({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Validate submit order request data
 * {@link /v1/orders/validate}
 */
export function useValidateSubmitOrder<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ValidateSubmitOrderStatus200,
      ResponseErrorConfig<
        ValidateSubmitOrderStatus400 | ValidateSubmitOrderStatus401 | ValidateSubmitOrderStatus500
      >,
      ValidateSubmitOrderOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? validateSubmitOrderMutationKey()

  const baseOptions = validateSubmitOrderMutationOptions(config) as UseMutationOptions<
    ValidateSubmitOrderStatus200,
    ResponseErrorConfig<
      ValidateSubmitOrderStatus400 | ValidateSubmitOrderStatus401 | ValidateSubmitOrderStatus500
    >,
    ValidateSubmitOrderOptions,
    TContext
  >

  return useMutation<
    ValidateSubmitOrderStatus200,
    ResponseErrorConfig<
      ValidateSubmitOrderStatus400 | ValidateSubmitOrderStatus401 | ValidateSubmitOrderStatus500
    >,
    ValidateSubmitOrderOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ValidateSubmitOrderStatus200,
    ResponseErrorConfig<
      ValidateSubmitOrderStatus400 | ValidateSubmitOrderStatus401 | ValidateSubmitOrderStatus500
    >,
    ValidateSubmitOrderOptions,
    TContext
  >
}
